const config = {
  apiDomain: process.env.VUE_APP_API_DOMAIN || 'weapp.migumaotrip.com',//不要带斜杠
  fileDomain: process.env.VUE_APP_FILE_DOMAIN || 'weapp.migumaotrip.com',//文件上传
  isHttps: true,
  timeOut: 10000,//请求超时时间
  apiList: {
    upload: {
      url: "/api/common/upload_image",
      method: 'post',
      comment: "上传图片"
    },
    addProduct: {
      url: "/api/product/add_product",
      method: 'post',
      comment: "发布产品"
    },
    editProduct: {
      url: "/api/product/edit_product",
      method: 'post',
      comment: "编辑产品"
    },
    productInfo: {
      url: "/api/product/product_info",
      method: 'get',
      comment: "船票详情"
    },
    couponListOptions: {
      url: "/api/coupon/coupon_list_options",
      method: 'get',
      comment: "船票详情"
    },
    productList: {
      url: "/api/product/product_list",
      method: 'get',
      comment: "产品列表"
    },
    onlineProductList: {
      url: "/api/product/online_product_list",
      method: 'get',
      comment: "产品列表(在售)"
    },
    liveList: {
      url: "/api/product/live_list",
      method: 'get',
      comment: "直播列表"
    },
    saveLive: {
      url: "/api/product/live_save",
      method: 'get',
      comment: "修改直播间"
    },
    delProduct: {
      url: "/api/product/del_product",
      method: 'get',
      comment: "删除产品"
    },
    getDistributionPrice: {
      url: "/api/distribution/get_price",
      method: 'get',
      comment: "获取分销价格"
    },
    setDistributionPrice: {
      url: "/api/distribution/set_price",
      method: 'post',
      comment: "设置分销价格"
    },
    addSailings: {
      url: "/api/sailings/add_sailings",
      method: 'post',
      comment: "添加航班信息"
    },
    getSailingsInfo: {
      url: "/api/sailings/get_sailings",
      method: 'get',
      comment: "获取航班信息"
    },
    sailingsList: {
      url: "/api/sailings/sailings_list",
      method: 'get',
      comment: "航班列表"
    },
    sailingsStockList: {
      url: "/api/sailings/sailing_stock_list",
      method: 'get',
      comment: "航班库存信息"
    },
    editSailingsStock: {
      url: "/api/sailings/update_stock",
      method: 'post',
      comment: "编辑库存"
    },
    delSingsList: {
      url: "/api/sailings/del_sailings",
      method: 'get',
      comment: "删除航班"
    },
    bindSingsList: {
      url: "/api/sailings/bind_sailing_list",
      method: 'get',
      comment: "已绑定的航班信息"
    },
    doBindSailings: {
      url: "/api/sailings/bind_sailing_ship",
      method: 'post',
      comment: "绑定航班和船票"
    },
    getScenicPftInfo: {
      url: "/api/pft/scenic_pft_info",
      method: 'get',
      comment: "景区和票付通的绑定信息"
    },
    getPftList: {
      url: "/api/pft/scenic_list",
      method: 'get',
      comment: "票付通商品列表"
    },
    getPftScenicList: {
      url: "/api/pft/ticket_list",
      method: 'get',
      comment: "票付通商品列表"
    },
    bindPft: {
      url: "/api/pft/bind_pft",
      method: 'post',
      comment: "绑定票付通关系"
    },
    setExtension: {
      url: "/api/goods_extension/post_extension",
      method: 'post',
      comment: "发布扩展信息(含编辑)"
    },
    getExtension: {
      url: "/api/goods_extension/extension_info",
      method: 'get',
      comment: "获取扩展信息"
    },
    addCate: {
      url: "/api/cate/add_cate",
      method: 'post',
      comment: "添加分类"
    },
    cateList: {
      url: "/api/cate/cate_list",
      method: 'get',
      comment: "分类列表"
    },
    cateInfo: {
      url: "/api/cate/cate_info",
      method: 'get',
      comment: "分类信息"
    },
    delCate: {
      url: "/api/cate/del_cate",
      method: 'get',
      comment: "删除分类"
    },
    adsList: {
      url: "/api/ads/ads_list",
      method: 'get',
      comment: "广告列表"
    },
    adsPosition: {
      url: "/api/ads/ads_position",
      method: 'get',
      comment: "广告列表"
    },
    postAds: {
      url: "/api/ads/post_ads",
      method: 'post',
      comment: "添加/修改广告"
    },
    adsInfo: {
      url: "/api/ads/ads_info",
      method: 'get',
      comment: "获取广告信息"
    },
    orderList: {
      url: "/api/order/order_list",
      method: 'get',
      comment: "订单列表"
    },
    exportOrder: {
      url: "/api/order/export_order_list",
      method: 'get',
      comment: "订单导出"
    },
    orderDetails: {
      url: "/api/order/admin/order_details",
      method: 'get',
      comment: "订单列表"
    },
    editOrder: {
      url: "/api/order/edit_order",
      method: 'post',
      comment: "修改订单"
    },
    cancelIntentionRefund: {
      url: "/api/order/cancel_intention_refund",
      method: 'post',
      comment: "取消用户退款申请（清空意向退款信息）"
    },
    checkOrder: {
      url: "/api/order/check_order",
      method: 'post',
      comment: "订单出票"
    },
    resolveOrder: {
      url: "/api/order/resolve_order",
      method: 'post',
      comment: "标记订单已沟通"
    },
    updateMeetingInfo: {
      url: "/api/order/update_meeting_info",
      method: 'post',
      comment: "修改已沟通订单的集合点信息"
    },
    ticketingList: {
      url: "/api/order/ticketing_list",
      method: 'get',
      comment: "出票处理列表"
    },
    exportTicketingList: {
      url: "/api/order/export_ticketing_list",
      method: 'get',
      comment: "导出出票处理列表"
    },
    markPeopleTicketed: {
      url: "/api/order/mark_people_ticketed",
      method: 'post',
      comment: "标记游客已出票"
    },
    todayCommunicateCount: {
      url: "/api/order/today_communicate_count",
      method: 'get',
      comment: "今日本人沟通笔数"
    },
    myCommunicateList: {
      url: "/api/order/my_communicate_list",
      method: 'get',
      comment: "本人沟通明细列表"
    },
    communicateDashboard: {
      url: "/api/order/communicate_dashboard",
      method: 'get',
      comment: "超管沟通统计看板"
    },
    communicateDashboardDetail: {
      url: "/api/order/communicate_dashboard_detail",
      method: 'get',
      comment: "超管某管理员沟通明细"
    },
    adminOptionsForCommunicate: {
      url: "/api/order/admin_options_for_communicate",
      method: 'get',
      comment: "管理员下拉选项（超管看板用）"
    },
    meetingPointList: {
      url: "/api/meeting_point/list",
      method: 'get',
      comment: "集合地点列表"
    },
    meetingPointOptions: {
      url: "/api/meeting_point/options",
      method: 'get',
      comment: "集合地点选项"
    },
    saveMeetingPoint: {
      url: "/api/meeting_point/save",
      method: 'post',
      comment: "保存集合地点"
    },
    deleteMeetingPoint: {
      url: "/api/meeting_point/delete",
      method: 'get',
      comment: "删除集合地点"
    },
    copyPeopleLog: {
      url: "/api/order/copy_people_log",
      method: 'post',
      comment: "记录复制信息"
    },
    addPeopleRemark: {
      url: "/api/order/add_people_remark",
      method: 'post',
      comment: "添加人员备注"
    },
    refundList: {
      url: "/api/refund/apply_list",
      method: 'get',
      comment: "退款列表"
    },
    passRefund: {
      url: "/api/refund/pass_refund",
      method: 'post',
      comment: "通过退款"
    },
    refuseRefund: {
      url: "/api/refund/refuse_refund",
      method: 'post',
      comment: "拒绝退款"
    },
    createRefund: {
      url: "/api/refund/create_refund",
      method: 'post',
      comment: "创建退款"
    },
    userList: {
      url: "/api/user/user_list",
      method: 'get',
      comment: "用户列表"
    },
    guideList: {
      url: "/api/guide/guide_list",
      method: 'get',
      comment: "讲师列表"
    },
    guideOptions: {
      url: "/api/guide/guide_options",
      method: 'get',
      comment: "讲师列表(枚举值)"
    },
    addGuide: {
      url: "/api/guide/add_guide",
      method: 'post',
      comment: "添加讲师"
    },
    editGuide: {
      url: "/api/guide/edit_guide",
      method: 'post',
      comment: "编辑讲师"
    },
    switchGuideStatus: {
      url: "/api/guide/switch_status",
      method: 'post',
      comment: "启用/禁用讲师"
    },
    setUserGroup: {
      url: "/api/user/set_user_group",
      method: 'post',
      comment: "删除用户组"
    },
    postGroup: {
      url: "/api/user/post_group",
      method: 'post',
      comment: "用户组列表"
    },
    groupList: {
      url: "/api/user/group_list",
      method: 'get',
      comment: "用户组列表"
    },
    delGroup: {
      url: "/api/user/del_group",
      method: 'get',
      comment: "删除用户组"
    },
    providerUserList: {
      url: "/api/user/provider_user_list",
      method: 'get',
      comment: "供应商用户列表"
    },
    AdminGroupList: {
      url: "/api/admin/group_list",
      method: 'get',
      comment: "管理员列表"
    },
    postAdminGroup: {
      url: "/api/admin/post_group",
      method: 'post',
      comment: "发布管理员用户组"
    },
    postAdminUser: {
      url: "/api/admin/post_admin_user",
      method: 'post',
      comment: "发布管理员"
    },
    adminUserList: {
      url: "/api/admin/admin_user_list",
      method: 'get',
      comment: "发布管理员"
    },
    switchAdminStatus: {
      url: "/api/admin/switch_admin_status",
      method: 'post',
      comment: "切换管理员状态"
    },
    editPwd: {
      url: "/api/admin/edit_pwd",
      method: 'post',
      comment: "修改密码"
    },
    getPrivilegeList: {
      url: "/api/admin/group_privilege_list",
      method: 'get',
      comment: "获取用户组以及全部权限"
    },
    putGroupPrivilege: {
      url: "/api/admin/put_group_privilege",
      method: 'post',
      comment: "用户组赋权"
    },
    groupProductScope: {
      url: "/api/admin/group_product_scope",
      method: 'get',
      comment: "用户组数据权限产品目录与已选"
    },
    putGroupProductScope: {
      url: "/api/admin/put_group_product_scope",
      method: 'post',
      comment: "保存用户组数据权限"
    },
    adminLogin: {
      url: "/api/admin/login",
      method: 'post',
      comment: "登录"
    },
    adminLogout: {
      url: "/api/admin/logout",
      method: 'post',
      comment: "退出"
    },
    allSettings: {
      url: "/api/settings/list",
      method: 'get',
      comment: "所有设置"
    },
    updateSettings: {
      url: "/api/settings/update",
      method: 'post',
      comment: "更新配置"
    },
    sosoConfigLList: {
      url: "/api/soso/config_list",
      method: 'get',
      comment: "搜一搜配置列表"
    },
    addSosoConfigLList: {
      url: "/api/soso/add_config",
      method: 'post',
      comment: "添加配置"
    },
    editSosoConfigLList: {
      url: "/api/soso/edit_config",
      method: 'post',
      comment: "编辑配置"
    },
    getSosoConfigLList: {
      url: "/api/soso/get_config",
      method: 'get',
      comment: "获取配置"
    },
    getSkuStockList: {
      url: "/api/product/sku_stock_list",
      method: 'get',
      comment: "获取产品库存"
    },
    setSkuStock: {
      url: "/api/product/set_sku_stock",
      method: 'get',
      comment: "设置产品库存"
    },
    cashList: {
      url: "/api/cash/apply_list",
      method: 'get',
      comment: "提现申请列表"
    },
    verifyCash: {
      url: "/api/cash/verify_cash",
      method: 'get',
      comment: "审核提现"
    },
    teamList: {
      url: "/api/distribution/team_list",
      method: 'get',
      comment: "合伙人列表"
    },
    appsList: {
      url: "/api/apps/app_list",
      method: 'get',
      comment: "应用列表"
    },
    setAppConfig: {
      url: "/api/apps/set_app_config",
      method: 'post',
      comment: "设置应用"
    },
    getAppConfig: {
      url: "/api/apps/get_app_config",
      method: 'get',
      comment: "获取配置"
    },
    deployCode: {
      url: "/api/apps/deploy_code",
      method: 'get',
      comment: "发布代码"
    },
    allPagePath: {
      url: "/api/apps/all_page_path",
      method: 'get',
      comment: "所有页面列表"
    },
    qrCode: {
      url: "/api/apps/qr_code",
      method: 'get',
      comment: "所有页面列表"
    },
    verifyCode: {
      url: "/api/apps/verify_code",
      method: 'get',
      comment: "提交代码审核任务"
    },
    postCode: {
      url: "/api/apps/post_code",
      method: 'get',
      comment: "发布代码到线上"
    },
    giftList: {
      url: "/api/order/gift_list",
      method: 'get',
      comment: "赠品列表"
    },
    orderStat: {
      url: "/api/order/order_stat",
      method: 'get',
      comment: "订单统计"
    },
    nightShipList: {
      url: "/api/night_ship/sailing_list",
      method: 'get',
      comment: "页游航班"
    },
    nightShipStock: {
      url: "/api/night_ship/stock_list",
      method: 'get',
      comment: "夜游航班库存列表"
    },
    nightShipOrderList: {
      url: "/api/night_ship/order_list",
      method: 'get',
      comment: "夜游订单列表"
    },
    skuOptions: {
      url: "/api/night_ship/options",
      method: 'get',
      comment: "夜游订单列表"
    },
    reconciliation: {
      url: "/api/night_ship/reconciliation_list",
      method: 'get',
      comment: "对账单"
    },
    batchChecked: {
      url: "/api/night_ship/reconciliation_batch_check",
      method: 'post',
      comment: "批量对账"
    },
    playList: {
      url: "/api/booking_play/play_list",
      method: 'get',
      comment: "预约场次管理"
    },
    bindPlayList: {
      url: "/api/booking_play/bind_play_list",
      method: 'get',
      comment: "某个产品已绑定的场次列表"
    },
    bindPlays: {
      url: "/api/product/bind_plays",
      method: 'get',
      comment: "给产品绑定场次"
    },
    addPlay: {
      url: "/api/booking_play/add_play",
      method: 'post',
      comment: "添加场次"
    },
    editPlay: {
      url: "/api/booking_play/edit_play",
      method: 'post',
      comment: "编辑场次"
    },
    switchPlayStatus: {
      url: "/api/booking_play/play_switch_status",
      method: 'post',
      comment: "编辑场次"
    },
    playDailyCalender: {
      url: "/api/booking_play/play_daily_calender",
      method: 'get',
      comment: "场次排班"
    },
    editPlayDaily: {
      url: "/api/booking_play/edit_play_daily",
      method: 'post',
      comment: "编辑排班"
    },
    myPrivilegeList: {
      url: "/api/admin/my_privilege",
      method: 'get',
      comment: "我的权限列表"
    },
    editPeopleSupplier: {
      url: "/api/order/edit_people_supplier",
      method: 'get',
      comment: "修改供应商"
    },
    delApp: {
      url: "/api/apps/del_app",
      method: 'get',
      comment: "删除小程序"
    },
    opWalletDetails: {
      url: "/api/op_wallet/details",
      method: 'get',
      comment: "明细"
    },
    opWalletBalance: {
      url: "/api/op_wallet/balance",
      method: 'get',
      comment: "明细"
    },
    opWalletRecharge: {
      url: "/api/op_wallet/recharge",
      method: 'post',
      comment: "充值运营豆"
    },
    isSuperAdmin: {
      url: "/api/admin/is_super_admin",
      method: 'get',
      comment: "判断是否为超管"
    },
    appListOptions: {
      url: "/api/apps/app_list_options",
      method: 'get',
      comment: "应用列表下拉选项"
    },
    getPeopleCount: {
      url: "/api/order/get_people_count",
      method: 'get',
      comment: "应用列表下拉选项"
    },
    getSailingsWithRencentStock: {
      url: "/api/sailings/sailings_with_recent_stock",
      method: 'get',
      comment: "获取最近有库存的航班列表"
    },
    // 合同管理
    contractTemplateList: {
      url: "/api/contract/template_list",
      method: 'get',
      comment: "合同模板列表"
    },
    addContractTemplate: {
      url: "/api/contract/add_template",
      method: 'post',
      comment: "新增合同模板"
    },
    editContractTemplate: {
      url: "/api/contract/edit_template",
      method: 'post',
      comment: "编辑合同模板"
    },
    getContractTemplate: {
      url: "/api/contract/get_template",
      method: 'get',
      comment: "获取合同模板详情"
    },
    delContractTemplate: {
      url: "/api/contract/del_template",
      method: 'get',
      comment: "删除合同模板"
    },
    contractVariableList: {
      url: "/api/contract/variable_list",
      method: 'get',
      comment: "合同变量列表"
    },
    renderContract: {
      url: "/api/contract/render_contract",
      method: 'get',
      comment: "渲染合同内容"
    },
    getContractDefaultTemplate: {
      url: "/api/contract/default_template",
      method: 'get',
      comment: "获取默认合同模板HTML"
    },
    // 供应商管理
    supplierList: {
      url: "/api/supplier/supplier_list",
      method: 'get',
      comment: "供应商分页列表"
    },
    allSuppliers: {
      url: "/api/supplier/all_suppliers",
      method: 'get',
      comment: "所有供应商（供下拉）"
    },
    addSupplier: {
      url: "/api/supplier/add_supplier",
      method: 'post',
      comment: "新增供应商"
    },
    editSupplier: {
      url: "/api/supplier/edit_supplier",
      method: 'post',
      comment: "编辑供应商"
    },
    getSupplier: {
      url: "/api/supplier/get_supplier",
      method: 'get',
      comment: "供应商详情"
    },
    delSupplier: {
      url: "/api/supplier/del_supplier",
      method: 'get',
      comment: "删除供应商"
    },
    intelligentChat: {
      url: "/api/intelligent/chat",
      method: 'post',
      comment: "智能中心对话"
    },
    // 支付商户管理
    payMerchantList: {
      url: "/api/pay_merchant/merchant_list",
      method: 'get',
      comment: "支付商户列表"
    },
    addPayMerchant: {
      url: "/api/pay_merchant/add_merchant",
      method: 'post',
      comment: "添加支付商户"
    },
    updatePayMerchant: {
      url: "/api/pay_merchant/update_merchant",
      method: 'post',
      comment: "更新支付商户"
    },
    getPayMerchant: {
      url: "/api/pay_merchant/get_merchant",
      method: 'get',
      comment: "获取支付商户详情"
    },
    deletePayMerchant: {
      url: "/api/pay_merchant/delete_merchant",
      method: 'get',
      comment: "删除支付商户"
    },
    payMerchantOptions: {
      url: "/api/pay_merchant/merchant_options",
      method: 'get',
      comment: "支付商户下拉选项"
    }
  }
};

export default config;




// WEBPACK FOOTER //
// ./src/api/config.js